// extracted by mini-css-extract-plugin
module.exports = {"duration":"zsFVV"};